import { render, staticRenderFns } from "./index.vue?vue&type=template&id=16fe8b98&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16fe8b98')) {
      api.createRecord('16fe8b98', component.options)
    } else {
      api.reload('16fe8b98', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=16fe8b98&", function () {
      api.rerender('16fe8b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/fund-config/modules/index.vue"
export default component.exports